export class Settings {

    animationTime: number;
    maxStakePerTip1: number;
    maxStakePerTip2: number;
    maxStakePerTip3: number;
    maxStakePerTip4: number;
    maxStakePerTip5: number;
    maxStakePerTip6: number;
    maxStakePerTip7: number;
    maxStakePerTip8: number;
    minStake: number = 1;
    maxDrawingRounds: number = 5;

    constructor(animationTime: number, maxStakePerTip1: number, maxStakePerTip2: number, maxStakePerTip3: number,
                maxStakePerTip4: number, maxStakePerTip5: number, maxStakePerTip6: number, maxStakePerTip7: number,
                maxStakePerTip8: number, minStake: number, maxDrawingRounds: number) {
        this.animationTime = animationTime;
        this.maxStakePerTip1 = maxStakePerTip1;
        this.maxStakePerTip2 = maxStakePerTip2;
        this.maxStakePerTip3 = maxStakePerTip3;
        this.maxStakePerTip4 = maxStakePerTip4;
        this.maxStakePerTip5 = maxStakePerTip5;
        this.maxStakePerTip6 = maxStakePerTip6;
        this.maxStakePerTip7 = maxStakePerTip7;
        this.maxStakePerTip8 = maxStakePerTip8;
        this.minStake = minStake;
        this.maxDrawingRounds = maxDrawingRounds;
    }

    getMaxStake(tipNumber: number, rounds: number): number {
        if (tipNumber >= 1 && tipNumber <= 8) {
            return this['maxStakePerTip' + tipNumber] * rounds;
        } else {
            return this.maxStakePerTip1 * rounds;
        }
    }

    getMinStake(rounds: number): number {
        return this.minStake * rounds;
    }

    static get defaultSettings(): Settings {
        return new Settings(10000, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5);
    }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/settings.ts